import { useState } from 'react';
import { ACTIONS, EventData, Status, STATUS, Step } from 'react-joyride';
import { useTranslation } from "react-i18next";

export const useReservationsTour = (
    setIsEditableMode: React.Dispatch<React.SetStateAction<boolean>>,
    setIsPreferenceEditorOpen: React.Dispatch<React.SetStateAction<boolean>>) => {

    const { t } = useTranslation("reservations");
    const [runTour, setRunTour] = useState(!localStorage.getItem('reservations_tour_completed'));
    const tourSteps: Step[] = [
        {
            target: '[data-tut="calendar"]',
            content: t('tour_calendar_content'),
            placement: 'top',
            skipBeacon: true
        },
        {
            target: '[data-tut="calendar"]',
            content: t('tour_calendar_day'),
            placement: 'top',
            skipBeacon: true
        },
        {
            target: '[data-tut="edit-toggle"]',
            content: t('tour_edit_toggle_content'),
            skipBeacon: true,
            placement: 'bottom',
            before: async () => setIsEditableMode(false),
            after: async (data) => {
                if (data.action !== ACTIONS.NEXT) {
                    setIsEditableMode(false);
                } else {
                    setIsEditableMode(true)
                }
            },
        },
        {
            target: '[data-tut="calendar"]',
            content: t('tour_calendar_editable'),
            placement: 'top',
        },
        {
            target: '[data-tut="preferences"]',
            content: t('tour_preferences'),
            placement: 'bottom',
            before: async () => setIsPreferenceEditorOpen(false),
        },
        {
            target: '[data-tut="preferences_edit"]',
            content: t('tour_preferences_edit'),
            placement: 'left',
            before: async () => setIsPreferenceEditorOpen(true),
            after: async () => setIsPreferenceEditorOpen(false),
        },
        {
            target: '[aria-label="dinsdag"], [aria-label="tuesday"]',
            content: t('tour_calendar_weekday_header'),
            placement: 'top',
            after: async (data) => {
                if (data.action !== ACTIONS.PREV) {
                    setIsEditableMode(false)
                }
            },
        },
    ];

    const handleJoyrideCallback = (data: EventData) => {
        const { status } = data;
        const finishedStatuses: Status[] = [STATUS.FINISHED, STATUS.SKIPPED];
        console.log("Joyride callback called with data " + { data })
        if (finishedStatuses.includes(status)) {
            setRunTour(false);
            localStorage.setItem('reservations_tour_completed', 'true');
        }
    };

    const restartTour = () => {
        localStorage.removeItem('reservations_tour_completed');
        setRunTour(true);
    };

    return {
        runTour,
        tourSteps,
        handleJoyrideCallback,
        restartTour
    }
}